jQuery(document).ready(function ($) {
    $('.switch-field').each(function(){
        if($(this).find('input:checked').val() === 'No'){
            $(this).toggleClass('inactive');
        }
    });
    $('.switch-field input[type=radio]').on('change', function(){
        let wrapper = $(this).closest('.switch-field');
        wrapper.toggleClass('inactive');
    });
});
